"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkBuilder = void 0;
var apollo_link_1 = require("apollo-link");
var LinkBuilder = /** @class */ (function () {
    function LinkBuilder() {
        this.links = [];
    }
    LinkBuilder.prototype.addLink = function () {
        var _a;
        var links = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            links[_i] = arguments[_i];
        }
        (_a = this.links).push.apply(_a, links);
        return this;
    };
    LinkBuilder.prototype.build = function () {
        return apollo_link_1.ApolloLink.from(this.links);
    };
    return LinkBuilder;
}());
exports.LinkBuilder = LinkBuilder;
//# sourceMappingURL=LinkBuilder.js.map